import {
  type AnswerValue,
  type QuizQuestion,
  QuizQuestionType,
} from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

/**
 * Add answers for questions that are not already in the values array.
 * @param questions - The questions to add answers for
 * @param values - The existing answers
 * @param params - The query parameters
 */
export function quizAnswers(
  questions: QuizQuestion[],
  values: AnswerValue[],
  params: Record<string, string>
) {
  const queryString: Record<string, string> = {};

  questions
    .filter((question) => !values.some((a) => a.qid == question.qid))
    .forEach((question) => {
      const answer: AnswerValue = {
        [Type]: DataTypeQuiz.AnswerValue,
        qid: question.qid,
        value: null,
      };
      if (question.type === QuizQuestionType.Hidden) {
        const query = question.hidden?.query;
        const defaultValue = question.hidden?.defaultValue || '';
        if (query) {
          if (query[0] === '$') {
            answer.value = params[query.substring(1)] || defaultValue;
          } else {
            answer.value = queryString[query] || defaultValue;
          }
        } else {
          answer.value = defaultValue;
        }
      }
      values.push(answer);
    });
}
